/* FTB - make the "+N" swatch overflow chip open the product page.
   Broadcast renders it as a plain <div class="swatch-limited">, so it needs
   wiring by hand. The card carries the product URL on data-url.

   Click handling uses EVENT DELEGATION on the document rather than per-element
   listeners. Related-product grids and quick-view load by AJAX after page load,
   and per-element wiring kept missing them; delegation cannot miss, because it
   does not care when the node appeared. The labelling pass below is cosmetic
   only, so if it lags behind an AJAX render the chip still works. */
(function () {
  function hit(e) {
    var el = e.target && e.target.closest && e.target.closest('.swatch-limited');
    if (!el) return null;
    var card = el.closest('.product-item');
    var url = card && card.getAttribute('data-url');
    return url ? url : null;
  }

  function go(e, url) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }

  document.addEventListener('click', function (e) {
    var url = hit(e);
    if (url) go(e, url);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var url = hit(e);
    if (url) go(e, url);
  }, true);

  /* Cosmetic: make the chip announce itself and take focus. */
  function label() {
    var els = document.querySelectorAll('.product-item .swatch-limited:not([data-ftb-more])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-ftb-more', '1');
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('title', 'See all colours');
      var n = (el.textContent || '').replace(/[^0-9]/g, '');
      if (n) el.setAttribute('aria-label', n + ' more colours, view product');
    });
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; label(); }, 100);
  }

  function boot() {
    label();
    if (document.body && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    // Catch sections that arrive after the observer is attached.
    setTimeout(label, 600);
    setTimeout(label, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', schedule);
})();

/* FTB - the orange ring follows the colour the card is actually showing.

   Two gaps this closes. First, the ring only ever existed on collection
   templates, because the rule that drew it lived in ftb-collection-header and
   was scoped to `.template-collection`; search results and related-product
   grids showed no ring at all. Second, it never moved: hover a different chip
   and the card changed image while the ring stayed on the original colour.

   The chip wearing `ftb-sw-showing` is the one whose colour is on screen. At
   rest that is the card's current colour, which the collection-header script
   marks with `ftb-sw-current` where it runs, falling back to the first chip
   everywhere else. While the pointer is on the card it is the hovered chip.

   Delegation again, for the usual reason: related grids and quick view render
   after page load. */
(function () {
  var lastCard = null;

  function chipsOf(card) {
    return card.querySelectorAll('grid-swatch [data-swatch-button]');
  }

  function defaultChip(card) {
    return card.querySelector('grid-swatch [data-swatch-button].ftb-sw-current')
        || card.querySelector('grid-swatch [data-swatch-button]');
  }

  function mark(card, chip) {
    Array.prototype.forEach.call(chipsOf(card), function (c) {
      if (c === chip) c.classList.add('ftb-sw-showing');
      else c.classList.remove('ftb-sw-showing');
    });
  }

  function hoveredChip(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    var chip = t.closest('[data-swatch-button]');
    if (!chip || !chip.closest('grid-swatch')) return null;
    return chip;
  }

  function onMove(e) {
    var t = e.target;
    var card = (t && t.closest) ? t.closest('[data-grid-item]') : null;

    // Left the card the ring was following, so put it back on that card's
    // resting colour. mouseleave does not bubble, so this is how we notice.
    if (lastCard && lastCard !== card) {
      mark(lastCard, defaultChip(lastCard));
      lastCard = null;
    }
    if (!card || !chipsOf(card).length) return;

    mark(card, hoveredChip(e) || defaultChip(card));
    lastCard = card;
  }

  /* Resting state. Re-run on DOM changes because ftb-sw-current is applied
     asynchronously after the collection header fetches the product, and
     because grids arrive by AJAX. Cheap: cards already correct are skipped,
     and the observer watches childList only, so our own class writes do not
     retrigger it. */
  function seed() {
    var cards = document.querySelectorAll('[data-grid-item]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card === lastCard) return;
      var want = defaultChip(card);
      if (!want || want.classList.contains('ftb-sw-showing')) return;
      mark(card, want);
    });
  }

  var t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () { t = null; seed(); }, 150);
  }

  function start() {
    seed();
    if (document.body && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(seed, 600);
    setTimeout(seed, 2000);
  }

  document.addEventListener('mouseover', onMove, true);
  document.addEventListener('focusin', onMove, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', schedule);
})();
